import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Chip,
  Typography,
  Button,
  Tooltip,
  IconButton,
  Snackbar,
  Alert,
  Grid,
  ButtonGroup,
  Skeleton,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { backend_api } from "../../../static/server";
import {
  getCaseByid,
  getPracticeArea,
} from "../../../redux/Apps/Lawyerapp/CaseSlice/CaseSlice";
import { useNavigate, useParams } from "react-router-dom";
import {
  appendTeamMemberLawyerId,
  generateUniqueMatterName,
} from "../../../styles/styles";
import { getActivities } from "../../../redux/Apps/Lawyerapp/ActivitySlice/ActivitySlice";
import { getAllBilles } from "../../../redux/Apps/Lawyerapp/BillingSlice/BillingSlice";
import { getAllTask } from "../../../redux/Apps/Lawyerapp/TaskSlice/TaskSlice";
import {
  AccessTimeRounded,
  AccountBalanceWalletRounded,
  AttachMoneyRounded,
  ContentCopy,
  DeleteRounded,
  DescriptionRounded,
  DriveFileRenameOutlineRounded,
  ExtensionRounded,
  HourglassEmptyRounded,
  MonetizationOnRounded,
  PaidRounded,
  ReceiptRounded,
  TrendingDownRounded,
  TrendingUpRounded,
  ErrorOutlineRounded,
} from "@mui/icons-material";
import TaskTableForDash from "../../../components/LawyerCompo/TableCompoForDashboards/TaskTableForDash";
import BillGenerateForm from "../../../components/LawyerCompo/Billing/BillGenrateForm";
import { useDialog } from "../../../components/DialogContext";
import ActivityTableForDash from "../../../components/LawyerCompo/TableCompoForDashboards/ActivityTableForDash";
import ServiceTimeForm from "../../../components/LawyerCompo/Activities/ActivitiesForms/ServiceTimeForm";
import ExpenseForm from "../../../components/LawyerCompo/Activities/ActivitiesForms/ExpenseForm";
import { getCurrencySymbol } from "../Settings/CurrencySetForm";
import MatterEditForm from "../../../components/LawyerCompo/Cases/MatterEditForm";
import { toast } from "react-toastify";
import BillTableForDash from "../../../components/LawyerCompo/TableCompoForDashboards/BillTableForDash";
import DocumentTableForDash from "../../../components/LawyerCompo/TableCompoForDashboards/DocumentTableForDash";
import RecordNotesPanel from "../../../components/LawyerCompo/Dashboard/RecordNotesPanel";
import { getAllDocFolder } from "../../../redux/Apps/Lawyerapp/DocumentSlice/DocumentSlice";
import axios from "axios";

const CaseDashboard = () => {
  const { showDialog } = useDialog();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const { token, teamMemberLawyerId } = useSelector((data) => data.user);
  const {
    caseData,
    loading: caseLoading,
    error: caseError,
  } = useSelector((state) => state.case);
  const {
    allActivities,
    loading: activityLoading,
    activitiesPagination,
    error: activityError,
  } = useSelector((state) => state.activity);
  const {
    allBilles,
    pagination: billingPagination,
    loading: billingLoading,
    error: billingError,
  } = useSelector((state) => state.billing);
  const {
    allTask,
    loading: taskLoading,
    taskPagination,
    error: taskError,
  } = useSelector((state) => state.task);

  const {
    allDocFolder,
    loading: docLoading,
    docFoldersPagination,
    error: docError,
  } = useSelector((state) => state.document);

  const {
    page: activityPage,
    pageSize: activityPageSize,
    rowCount: activityRowCount,
    nextPage: activityNextPage,
    previousPage: activityPreviousPage,
  } = activitiesPagination || {};

  const {
    page: billPage,
    pageSize: billPageSize,
    rowCount: billRowCount,
    nextPage: billNextPage,
    previousPage: billPreviousPage,
  } = billingPagination || {};

  const {
    page: taskPage,
    pageSize: taskPageSize,
    rowCount: taskRowCount,
    nextPage: taskNextPage,
    previousPage: taskPreviousPage,
  } = taskPagination || {};

  const {
    page: docPage,
    pageSize: docPageSize,
    rowCount: docRowCount,
    nextPage: docNextPage,
    previousPage: docPreviousPage,
  } = docFoldersPagination || {};

  const [deleteLoad, setDeleteLoad] = useState(false);
  const [activeTab, setActiveTab] = useState("Dashboard");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [copiedField, setCopiedField] = useState("");
  const [matterCurrencySymbol, setMatterCurrencySymbol] = useState("$");
  const [currentFolderId, setCurrentFolderId] = useState(null);
  const [foldersBreadcrumbs, setFoldersBreadcrumbs] = useState([]);
  const [pageNotFound, setPageNotFound] = useState(false);

  // Check for 404 errors
  useEffect(() => {
    if (caseError?.response?.status === 404) {
      setPageNotFound(true);
    } else {
      setPageNotFound(false);
    }
  }, [caseError, activityError, billingError, taskError, docError]);

  // Fetch all data
  useEffect(() => {
    if (!id || pageNotFound) return;

    dispatch(
      getCaseByid({
        url: appendTeamMemberLawyerId(
          `${backend_api}case/register/${id}/`,
          teamMemberLawyerId,
        ),
        token: token,
        teamMemberLawyerId,
      }),
    );

    dispatch(
      getPracticeArea({
        url: `${backend_api}case/case-type/?case_service_type=practice_area`,
        token: token,
      }),
    );

    dispatch(
      getActivities({
        url: `${backend_api}firm-case/expense/?case=${id}`,
        token: token,
        page: activityPage,
        pageSize: activityPageSize,
        teamMemberLawyerId,
      }),
    );

    dispatch(
      getAllBilles({
        url: `${backend_api}firm-case/bill/?case=${id}`,
        token: token,
        page: billPage,
        pageSize: billPageSize,
        teamMemberLawyerId,
      }),
    );

    dispatch(
      getAllTask({
        url: `${backend_api}task/task-register/?case=${id}`,
        token: token,
        page: taskPage,
        pageSize: taskPageSize,
        teamMemberLawyerId,
      }),
    );
    dispatch(
      getAllDocFolder({
        url: `${backend_api}documents/document/folder/?parent__isnull=true&case=${id}`,
        token,
        page: docPage,
        pageSize: docPageSize,
        teamMemberLawyerId,
      }),
    );
  }, [dispatch, id, teamMemberLawyerId, token, pageNotFound]);

  // Loading state
  const isLoading = useMemo(() => {
    return (
      caseLoading ||
      activityLoading ||
      billingLoading ||
      taskLoading ||
      docLoading
    );
  }, [caseLoading, activityLoading, billingLoading, taskLoading, docLoading]);

  // Financial calculations
  const nonBillableAmount = useMemo(() => {
    if (!Array.isArray(allActivities)) return 0;
    return allActivities
      .filter((item) => item.non_billable && !item.bill_genrated)
      .reduce((sum, item) => sum + parseFloat(item.total_payment || 0), 0);
  }, [allActivities]);

  const wipAmount = useMemo(() => {
    if (!Array.isArray(allActivities)) return 0;
    return allActivities
      .filter((item) => !item.bill_genrated && !item.non_billable)
      .reduce((sum, item) => sum + parseFloat(item.total_payment || 0), 0);
  }, [allActivities]);

  const totalBilled = useMemo(() => {
    if (!Array.isArray(allBilles)) return 0;
    return allBilles.reduce(
      (sum, bill) => sum + parseFloat(bill.total_amount || 0),
      0,
    );
  }, [allBilles]);

  const totalCollected = useMemo(() => {
    if (!Array.isArray(allBilles)) return 0;
    return allBilles.reduce(
      (sum, bill) => sum + parseFloat(bill.payment_received || 0),
      0,
    );
  }, [allBilles]);

  const outstandingBalance = useMemo(() => {
    return totalBilled - totalCollected;
  }, [totalBilled, totalCollected]);

  const matterTrustFunds = useMemo(() => {
    return (
      parseFloat(caseData?.trust_deposits || 0) -
      parseFloat(caseData?.trust_applied || 0)
    );
  }, [caseData]);

  const matterBudget = useMemo(
    () => parseFloat(caseData?.budget || 0),
    [caseData],
  );

  const usedBudgetValue = useMemo(
    () => totalBilled + wipAmount,
    [totalBilled, wipAmount],
  );

  const usedBudgetPercent = useMemo(() => {
    if (!matterBudget) return 0;
    const percent = (usedBudgetValue / matterBudget) * 100;
    return percent > 100 ? 100 : percent;
  }, [usedBudgetValue, matterBudget]);

  const timeEntries = useMemo(() => {
    if (!Array.isArray(allActivities)) return [];
    return allActivities.filter((a) => a.type === "time");
  }, [allActivities]);

  const totalTimeHours = useMemo(() => {
    return timeEntries.reduce((sum, item) => {
      if (item.time_in && item.time_out) {
        const diff = new Date(item.time_out) - new Date(item.time_in);
        return sum + diff / 3600000;
      }
      return sum;
    }, 0);
  }, [timeEntries]);

  const unbilledTimeHours = useMemo(() => {
    return timeEntries.reduce((sum, item) => {
      if (!item.bill_genrated && item.time_in && item.time_out) {
        const diff = new Date(item.time_out) - new Date(item.time_in);
        return sum + diff / 3600000;
      }
      return sum;
    }, 0);
  }, [timeEntries]);

  const expenseEntries = useMemo(() => {
    if (!Array.isArray(allActivities)) return [];
    return allActivities.filter((a) => a.type === "expense");
  }, [allActivities]);

  const totalExpenses = useMemo(() => {
    return expenseEntries.reduce(
      (sum, item) => sum + parseFloat(item.total_payment || 0),
      0,
    );
  }, [expenseEntries]);

  const unbilledExpenses = useMemo(() => {
    return expenseEntries.reduce((sum, item) => {
      if (!item.bill_genrated && !item.non_billable) {
        return sum + parseFloat(item.total_payment || 0);
      }
      return sum;
    }, 0);
  }, [expenseEntries]);

  const financialData = useMemo(() => {
    return {
      workInProgress: {
        amount: wipAmount,
        unbilled: wipAmount,
        nonBillable: nonBillableAmount,
      },
      outstandingBalance: {
        amount: outstandingBalance,
      },
      clientTrustFunds: {
        amount: matterTrustFunds,
      },
      matterBudget: {
        amount: matterBudget,
        usedAmount: usedBudgetValue,
        usedPercent: usedBudgetPercent,
      },
      timeTracking: {
        totalHours: totalTimeHours,
        unbilledHours: unbilledTimeHours,
        entries: timeEntries.length,
      },
      expenses: {
        totalAmount: totalExpenses,
        unbilledAmount: unbilledExpenses,
        entries: expenseEntries.length,
      },
      billing: {
        totalBilled: totalBilled,
        totalCollected: totalCollected,
        billsCount: allBilles?.length || 0,
      },
    };
  }, [
    wipAmount,
    nonBillableAmount,
    outstandingBalance,
    matterTrustFunds,
    matterBudget,
    usedBudgetValue,
    usedBudgetPercent,
    totalTimeHours,
    unbilledTimeHours,
    timeEntries,
    totalExpenses,
    unbilledExpenses,
    expenseEntries,
    totalBilled,
    totalCollected,
    allBilles,
  ]);

  const quickBillRows = useMemo(() => {
    if (!Array.isArray(allActivities)) return [];
    return allActivities
      .filter((item) => !item.bill_genrated && !item.non_billable)
      .map((item) => {
        let duration = "-";
        if (item.type === "time" && item.time_in && item.time_out) {
          const diffMs = new Date(item.time_out) - new Date(item.time_in);
          const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
          const diffMinutes = Math.floor(
            (diffMs % (1000 * 60 * 60)) / (1000 * 60),
          );
          duration = `${diffHours}h ${diffMinutes}m`;
        }

        return {
          id: item.id,
          user:
            (item.lawyer?.first_name || "") +
            " " +
            (item.lawyer?.last_name || ""),
          type: item.type,
          description: item.description,
          matter_name: item.case?.case_name
            ? generateUniqueMatterName(item.case.id, item.case.case_name)
            : "-",
          quantity: item.type === "time" ? duration : item.quantity,
          rate: item.hourly_rate,
          non_billable_amount: item.non_billable ? item.total_payment : "-",
          billable_amount: item.non_billable ? "-" : item.total_payment,
          create_at: item.created_at,
          category_name: item.category?.name,
          bill_entry_show: item.bill_entry_show,
          time_in: item.time_in,
          time_out: item.time_out,
          hourly_rate: item.hourly_rate,
          is_paid: item.is_paid,
          non_billable: item.non_billable,
          case: item.case?.id,
          category: item.category?.id,
          client: item.case?.case_related_person?.id,
          bill_genrated: item.bill_genrated,
        };
      });
  }, [allActivities]);

  const customFieldSections = useMemo(() => {
    if (Array.isArray(caseData?.custom_fields_data)) {
      const sectionMap = new Map();
      caseData.custom_fields_data.forEach((sectionObj) => {
        const name = Object.keys(sectionObj)[0] || "Custom Fields";
        const fields = sectionObj[name] || [];
        if (sectionMap.has(name)) {
          sectionMap.set(name, [...sectionMap.get(name), ...fields]);
        } else {
          sectionMap.set(name, fields);
        }
      });

      const sections = Array.from(sectionMap.entries()).map(
        ([sectionName, fields]) => ({
          sectionName,
          fields,
        }),
      );

      const rootIndex = sections.findIndex(
        (section) => section.sectionName?.toLowerCase() === "root",
      );
      if (rootIndex > 0) {
        const [rootSection] = sections.splice(rootIndex, 1);
        sections.unshift(rootSection);
      }

      return sections;
    }

    if (
      caseData?.custom_fields_data &&
      typeof caseData.custom_fields_data === "object"
    ) {
      const flatFields = Object.entries(caseData.custom_fields_data)
        .map(([fieldName, fieldValue]) => {
          if (
            fieldValue &&
            typeof fieldValue === "object" &&
            !Array.isArray(fieldValue)
          ) {
            return {
              name: fieldName,
              label: fieldValue.label || fieldName,
              field_type:
                fieldValue.field_type || fieldValue.type || "single_line",
              ...fieldValue,
            };
          }

          return {
            name: fieldName,
            label: fieldName,
            field_type: "single_line",
            value: fieldValue,
          };
        })
        .filter((field) => field.name);

      return flatFields.length
        ? [{ sectionName: "Custom Fields", fields: flatFields }]
        : [];
    }

    return [];
  }, [caseData]);

  useEffect(() => {
    setMatterCurrencySymbol(getCurrencySymbol(caseData?.currency));
  }, [caseData]);

  const copyToClipboard = async (text, fieldName) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedField(fieldName);
      setSnackbarOpen(true);
      setTimeout(() => setCopiedField(""), 2000);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  const CopyIconButton = ({ text, fieldName }) => (
    <Tooltip
      title={copiedField === fieldName ? "Copied!" : "Copy to clipboard"}
      arrow
    >
      <IconButton
        size="small"
        onClick={() => copyToClipboard(text, fieldName)}
        sx={{
          ml: 0.5,
          color: copiedField === fieldName ? "#10b981" : "#9ca3af",
          "&:hover": {
            color: "#3b82f6",
            backgroundColor: "#eff6ff",
          },
          p: "0.375rem",
          transition: "all 0.2s",
        }}
      >
        <ContentCopy sx={{ fontSize: "1rem" }} />
      </IconButton>
    </Tooltip>
  );

  const handleEditCase = () => {
    const editData = caseData;

    const sections =
      editData?.custom_fields?.[0]?.field_data?.createNewMatter?.sections ||
      editData?.link_template?.custom_fields?.[0]?.field_data?.createNewMatter
        ?.sections ||
      [];
    if (!sections.length) {
      toast.error("No form available for this matter");
      return;
    }
    showDialog(<MatterEditForm editData={editData} />, {
      dialogTitle: "Preview Form",
      fullScreen: true,
      width: "100%",
      formType: "matter",
    });
  };

  const handleDeleteCase = async () => {
    setDeleteLoad(true);
    try {
      const res = await axios.delete(`${backend_api}case/register/${id}/`, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });
      if (res?.status === 204) {
        navigate("/dashboard/matter");
        toast.success("Matter deleted successfully");
        return res;
      }
    } catch (error) {
      toast.error("Failed to delete the matter. Please try again");
    } finally {
      setDeleteLoad(false);
    }
  };
  const handleBulkBill = () => {
    if (quickBillRows.length === 0) return;

    const billableRows = quickBillRows.filter((row) => !row.bill_genrated);

    if (billableRows.length === 0) {
      return;
    }

    showDialog(<BillGenerateForm entryData={billableRows} />, {
      dialogTitle: "Draft Quick Bill",
    });
  };

  const handleTaskPageChange = (newPage) => {
    dispatch(
      getAllTask({
        url: `${backend_api}task/task-register/?case=${id}`,
        token: token,
        page: newPage,
        pageSize: taskPageSize,
        teamMemberLawyerId,
      }),
    );
  };

  const handleActivityPageChange = (newPage) => {
    dispatch(
      getActivities({
        url: `${backend_api}firm-case/expense/?case=${id}`,
        token: token,
        page: newPage,
        pageSize: activityPageSize,
        teamMemberLawyerId,
      }),
    );
  };

  const handleBillPageChange = (newPage) => {
    dispatch(
      getAllBilles({
        url: `${backend_api}firm-case/bill/?case=${id}`,
        token: token,
        page: newPage,
        pageSize: billPageSize,
        teamMemberLawyerId,
      }),
    );
  };

  const handleDocumentPageChange = (newPage) => {
    dispatch(
      getAllDocFolder({
        url: currentFolderId
          ? `${backend_api}documents/document/folder/?parent=${currentFolderId}`
          : `${backend_api}documents/document/folder/?parent__isnull=true`,
        token,
        page: newPage,
        pageSize: docPageSize,
        teamMemberLawyerId,
      }),
    );
  };

  const handleFolderNavigate = (row) => {
    if (row.type !== "folder") return;
    const nextBreadcrumbs = [
      ...foldersBreadcrumbs,
      { id: row.id, name: row.name },
    ];
    setFoldersBreadcrumbs(nextBreadcrumbs);
    setCurrentFolderId(row.id);
    dispatch(
      getAllDocFolder({
        url: `${backend_api}documents/document/folder/?parent=${row.id}`,
        token,
        page: 1,
        pageSize: docPageSize,
        teamMemberLawyerId,
      }),
    );
  };

  // Skeleton Components
  const HeaderSkeleton = () => (
    <Box sx={{ width: "100%", position: "relative" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          mb: "1rem",
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr auto",
            gap: { xs: "0.75rem", sm: "1rem" },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              flexWrap: "wrap",
            }}
          >
            <Skeleton variant="text" width={200} height={32} />
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="text" width={100} height={24} />
            <Skeleton variant="circular" width={24} height={24} />
            <Skeleton variant="text" width={20} height={24} />
            <Skeleton variant="rounded" width={80} height={24} />
          </Box>
          <Box sx={{ display: "flex", gap: "1rem" }}>
            <Skeleton variant="rounded" width={120} height={36} />
            <Skeleton variant="rounded" width={100} height={36} />
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: "0.5rem",
            p: "0.2rem",
            width: "fit-content",
          }}
        >
          {[
            "Dashboard",
            "Matter Detail",
            "Tasks",
            "Activity",
            "Bills",
            "Documents",
            "Notes",
          ].map((tab) => (
            <Skeleton
              key={tab}
              variant="rounded"
              width={90}
              height={36}
              sx={{ borderRadius: "2rem" }}
            />
          ))}
        </Box>
      </Box>
    </Box>
  );

  const DashboardTabSkeleton = () => (
    <Box
      sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 2 }}
    >
      {/* Financial Overview Cards Skeleton */}
      <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap", mb: 1 }}>
        {[1, 2, 3, 4].map((i) => (
          <Box
            key={i}
            sx={{
              flex: "1 1 200px",
              minHeight: 120,
              p: 2,
              borderRadius: "0.75rem",
              backgroundColor: "#f8fafc",
              border: "1px solid #e2e8f0",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
              <Skeleton variant="circular" width={32} height={32} />
              <Skeleton variant="text" width={120} height={20} />
            </Box>
            <Skeleton variant="text" width={100} height={32} sx={{ mb: 1 }} />
            <Skeleton variant="text" width={150} height={20} />
          </Box>
        ))}
      </Box>

      {/* Second Row Skeleton */}
      <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap", mb: 2 }}>
        {[1, 2, 3, 4].map((i) => (
          <Box
            key={i}
            sx={{
              flex: "1 1 180px",
              p: 1.5,
              borderRadius: "0.75rem",
              backgroundColor: "#f8fafc",
              border: "1px solid #e2e8f0",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
              <Skeleton variant="circular" width={28} height={28} />
              <Skeleton variant="text" width={80} height={20} />
            </Box>
            <Skeleton variant="text" width={100} height={28} sx={{ mb: 1 }} />
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Skeleton variant="text" width={60} height={20} />
              <Skeleton variant="text" width={80} height={20} />
            </Box>
          </Box>
        ))}
      </Box>

      {/* Quick Bill Table Skeleton */}
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: "0.8rem",
          p: "1rem",
          border: "1px solid #e5e7eb",
          mb: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Skeleton variant="text" width={150} height={24} />
          <Skeleton variant="text" width={100} height={20} />
        </Box>
        <Box sx={{ maxHeight: 300, overflow: "hidden" }}>
          {[1, 2, 3, 4, 5].map((i) => (
            <Box
              key={i}
              sx={{
                display: "flex",
                alignItems: "center",
                py: 1.5,
                borderBottom: i < 5 ? "1px solid #f3f4f6" : "none",
              }}
            >
              <Skeleton variant="text" width="40%" height={20} sx={{ mr: 2 }} />
              <Skeleton
                variant="rounded"
                width={60}
                height={24}
                sx={{ mr: 2 }}
              />
              <Skeleton variant="text" width={80} height={20} sx={{ mr: 2 }} />
              <Skeleton variant="text" width={80} height={20} />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );

  const MatterDetailSkeleton = () => (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      {/* Matter Information Skeleton */}
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: "0.8rem",
          p: "1rem",
          border: "1px solid #e5e7eb",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            mb: "1.5rem",
          }}
        >
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton variant="text" width={150} height={24} />
        </Box>
        <Grid container spacing={2.5}>
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <Box>
                <Skeleton
                  variant="text"
                  width={100}
                  height={16}
                  sx={{ mb: 1 }}
                />
                <Skeleton variant="text" width={150} height={20} />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Billing Information Skeleton */}
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: "0.8rem",
          p: "1rem",
          border: "1px solid #e5e7eb",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            mb: "1.5rem",
          }}
        >
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton variant="text" width={150} height={24} />
        </Box>
        <Grid container spacing={2.5}>
          {[1, 2, 3, 4].map((i) => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <Box>
                <Skeleton
                  variant="text"
                  width={100}
                  height={16}
                  sx={{ mb: 1 }}
                />
                <Skeleton variant="text" width={120} height={20} />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Custom Fields Skeleton */}
      <Box
        sx={{
          backgroundColor: "#fff",
          borderRadius: "0.8rem",
          p: "1rem",
          border: "1px solid #e5e7eb",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            mb: "1.5rem",
          }}
        >
          <Skeleton variant="circular" width={32} height={32} />
          <Skeleton variant="text" width={120} height={24} />
        </Box>
        <Grid container spacing={2.5}>
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <Grid item xs={12} sm={6} md={4} key={i}>
              <Box>
                <Skeleton
                  variant="text"
                  width={120}
                  height={16}
                  sx={{ mb: 1 }}
                />
                <Skeleton variant="text" width={180} height={20} />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );

  const TableSkeleton = ({ rows = 5, columns = 4 }) => (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: "0.8rem",
        p: "1rem",
        border: "1px solid #e5e7eb",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Skeleton variant="text" width={200} height={24} />
        <Skeleton variant="rounded" width={100} height={36} />
      </Box>
      <Box>
        {/* Header Row */}
        <Box
          sx={{
            display: "flex",
            gap: 2,
            mb: 1,
            pb: 1,
            borderBottom: "1px solid #e5e7eb",
          }}
        >
          {Array.from({ length: columns }).map((_, i) => (
            <Skeleton
              key={i}
              variant="text"
              width={`${100 / columns}%`}
              height={20}
            />
          ))}
        </Box>
        {/* Data Rows */}
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <Box
            key={rowIndex}
            sx={{
              display: "flex",
              gap: 2,
              py: 1.5,
              borderBottom: rowIndex < rows - 1 ? "1px solid #f3f4f6" : "none",
            }}
          >
            {Array.from({ length: columns }).map((_, colIndex) => (
              <Skeleton
                key={colIndex}
                variant="text"
                width={`${100 / columns}%`}
                height={20}
              />
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  );

  const NotFoundPage = () => (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        textAlign: "center",
        px: 2,
      }}
    >
      <ErrorOutlineRounded
        sx={{
          fontSize: 80,
          color: "#ef4444",
          mb: 3,
          opacity: 0.8,
        }}
      />
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          color: "#111827",
          mb: 1.5,
        }}
      >
        Matter Not Found
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: "#6b7280",
          mb: 3,
          maxWidth: "400px",
        }}
      >
        The matter you're looking for doesn't exist or you don't have permission
        to access it.
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate("/dashboard/matter")}
        sx={{
          textTransform: "none",
          px: 3,
          py: 1,
          borderRadius: "0.75rem",
          bgcolor: "#3b82f6",
          "&:hover": {
            bgcolor: "#2563eb",
          },
        }}
      >
        Back to Matters
      </Button>
    </Box>
  );

  const tabComponents = {
    Dashboard: isLoading ? (
      <DashboardTabSkeleton />
    ) : (
      <Box
        sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 2 }}
      >
        {/* Financial Overview Cards */}
        <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap", mb: 1 }}>
          {/* Work in Progress */}
          <Box
            sx={{
              flex: "1 1 200px",
              minHeight: 120,
              p: 2,
              borderRadius: "0.75rem",
              background: "linear-gradient(135deg, #FFFBEB 0%, #FEF3C7 100%)",
              border: "1px solid #FBBF24",
              position: "relative",
              overflow: "hidden",
              transition: "transform 0.2s",
              "&:hover": {
                transform: "translateY(-0.25rem)",
              },
            }}
          >
            <Box
              sx={{
                position: "absolute",
                right: "-1rem",
                bottom: "-1rem",
                opacity: 0.15,
                transform: "rotate(-15deg)",
              }}
            >
              <HourglassEmptyRounded
                sx={{ fontSize: "7rem", color: "#D97706" }}
              />
            </Box>
            <Box sx={{ position: "relative", zIndex: 1 }}>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}
              >
                <Box
                  sx={{
                    width: 32,
                    height: 32,
                    borderRadius: "8px",
                    bgcolor: "rgba(245, 158, 11, 0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <HourglassEmptyRounded
                    sx={{ fontSize: "1rem", color: "#D97706" }}
                  />
                </Box>
                <Typography
                  variant="caption"
                  sx={{
                    fontWeight: 600,
                    color: "#92400E",
                    textTransform: "uppercase",
                  }}
                >
                  Work in Progress
                </Typography>
              </Box>
              <Typography
                sx={{ fontWeight: 700, color: "#92400E", fontSize: "1.5rem" }}
              >
                {matterCurrencySymbol}
                {financialData.workInProgress.amount.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: "#92400E",
                  opacity: 0.8,
                  mt: 0.5,
                  display: "block",
                }}
              >
                {financialData.workInProgress.unbilled > 0
                  ? `${matterCurrencySymbol}${financialData.workInProgress.unbilled.toLocaleString()} unbilled`
                  : "All billed"}
              </Typography>
            </Box>
          </Box>

          {/* Outstanding Balance */}
          <Box
            sx={{
              flex: "1 1 200px",
              minHeight: 120,
              p: 2,
              borderRadius: "0.75rem",
              background: "linear-gradient(135deg, #FEE2E2 0%, #FECACA 100%)",
              border: "1px solid #F87171",
              position: "relative",
              overflow: "hidden",
              transition: "transform 0.2s",
              "&:hover": {
                transform: "translateY(-0.25rem)",
              },
            }}
          >
            <Box
              sx={{
                position: "absolute",
                right: "-1rem",
                bottom: "-1rem",
                opacity: 0.15,
              }}
            >
              {financialData.outstandingBalance.amount >= 0 ? (
                <TrendingUpRounded
                  sx={{ fontSize: "7rem", color: "#DC2626" }}
                />
              ) : (
                <TrendingDownRounded
                  sx={{ fontSize: "7rem", color: "#DC2626" }}
                />
              )}
            </Box>
            <Box sx={{ position: "relative", zIndex: 1 }}>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}
              >
                <Box
                  sx={{
                    width: 32,
                    height: 32,
                    borderRadius: "8px",
                    bgcolor: "rgba(239, 68, 68, 0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <MonetizationOnRounded
                    sx={{ fontSize: "1rem", color: "#DC2626" }}
                  />
                </Box>
                <Typography
                  variant="caption"
                  sx={{
                    fontWeight: 600,
                    color: "#991B1B",
                    textTransform: "uppercase",
                  }}
                >
                  Outstanding Balance
                </Typography>
              </Box>
              <Typography
                sx={{ fontWeight: 700, color: "#991B1B", fontSize: "1.5rem" }}
              >
                {financialData.outstandingBalance.amount >= 0 ? "" : "-"}
                {matterCurrencySymbol}
                {Math.abs(
                  financialData.outstandingBalance.amount,
                ).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: "#991B1B",
                  opacity: 0.8,
                  mt: 0.5,
                  display: "block",
                }}
              >
                {financialData.outstandingBalance.amount >= 0
                  ? "Client owes"
                  : "Credit balance"}
              </Typography>
            </Box>
          </Box>

          {/* Client Trust Funds */}
          <Box
            sx={{
              flex: "1 1 200px",
              minHeight: 120,
              p: 2,
              borderRadius: "0.75rem",
              background: "linear-gradient(135deg, #ECFDF5 0%, #D1FAE5 100%)",
              border: "1px solid #34D399",
              position: "relative",
              overflow: "hidden",
              transition: "transform 0.2s",
              "&:hover": {
                transform: "translateY(-0.25rem)",
              },
            }}
          >
            <Box
              sx={{
                position: "absolute",
                right: "-1rem",
                bottom: "-1rem",
                opacity: 0.15,
                transform: "rotate(-15deg)",
              }}
            >
              <AccountBalanceWalletRounded
                sx={{ fontSize: "7rem", color: "#059669" }}
              />
            </Box>
            <Box sx={{ position: "relative", zIndex: 1 }}>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}
              >
                <Box
                  sx={{
                    width: 32,
                    height: 32,
                    borderRadius: "8px",
                    bgcolor: "rgba(16, 185, 129, 0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <AccountBalanceWalletRounded
                    sx={{ fontSize: "1rem", color: "#059669" }}
                  />
                </Box>
                <Typography
                  variant="caption"
                  sx={{
                    fontWeight: 600,
                    color: "#065F46",
                    textTransform: "uppercase",
                  }}
                >
                  Client Trust Funds
                </Typography>
              </Box>
              <Typography
                sx={{ fontWeight: 700, color: "#065F46", fontSize: "1.5rem" }}
              >
                {matterCurrencySymbol}
                {financialData.clientTrustFunds.amount.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: "#065F46",
                  opacity: 0.8,
                  mt: 0.5,
                  display: "block",
                }}
              >
                Available balance
              </Typography>
            </Box>
          </Box>

          {/* Matter Budget */}
          <Box
            sx={{
              flex: "1 1 200px",
              minHeight: 120,
              p: 2,
              borderRadius: "0.75rem",
              background: "linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 100%)",
              border: "1px solid #60A5FA",
              position: "relative",
              overflow: "hidden",
              transition: "transform 0.2s",
              "&:hover": {
                transform: "translateY(-0.25rem)",
              },
            }}
          >
            <Box
              sx={{
                position: "absolute",
                right: "-1rem",
                bottom: "-1rem",
                opacity: 0.15,
                transform: "rotate(-15deg)",
              }}
            >
              <AttachMoneyRounded sx={{ fontSize: "7rem", color: "#2563EB" }} />
            </Box>
            <Box sx={{ position: "relative", zIndex: 1 }}>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}
              >
                <Box
                  sx={{
                    width: 32,
                    height: 32,
                    borderRadius: "8px",
                    bgcolor: "rgba(59, 130, 246, 0.2)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <AttachMoneyRounded
                    sx={{ fontSize: "1rem", color: "#2563EB" }}
                  />
                </Box>
                <Typography
                  variant="caption"
                  sx={{
                    fontWeight: 600,
                    color: "#1E40AF",
                    textTransform: "uppercase",
                  }}
                >
                  Matter Budget
                </Typography>
              </Box>
              <Typography
                sx={{ fontWeight: 700, color: "#1E40AF", fontSize: "1.5rem" }}
              >
                {matterCurrencySymbol}
                {financialData.matterBudget.amount.toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
              </Typography>
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}
              >
                <Box
                  sx={{
                    flex: 1,
                    height: 4,
                    bgcolor: "#E5E7EB",
                    borderRadius: 2,
                    overflow: "hidden",
                  }}
                >
                  <Box
                    sx={{
                      width: `${financialData.matterBudget.usedPercent}%`,
                      height: "100%",
                      bgcolor:
                        financialData.matterBudget.usedPercent > 80
                          ? "#EF4444"
                          : "#2563EB",
                      borderRadius: 2,
                    }}
                  />
                </Box>
                <Typography
                  variant="caption"
                  sx={{ color: "#1E40AF", fontWeight: 600 }}
                >
                  {financialData.matterBudget.usedPercent.toFixed(0)}%
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* Second Row - Time, Expenses, Billing */}
        <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap", mb: 2 }}>
          {/* Time Tracking */}
          <Box
            sx={{
              flex: "1 1 180px",
              p: 1.5,
              borderRadius: "0.75rem",
              bgcolor: "#F8FAFC",
              border: "1px solid #E2E8F0",
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box
                sx={{
                  width: 28,
                  height: 28,
                  borderRadius: "6px",
                  bgcolor: "#EDE9FE",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <AccessTimeRounded
                  sx={{ fontSize: "0.9rem", color: "#8B5CF6" }}
                />
              </Box>
              <Typography
                variant="caption"
                sx={{ fontWeight: 600, color: "#475569" }}
              >
                Time Tracking
              </Typography>
            </Box>
            <Typography
              sx={{ fontWeight: 700, color: "#1E293B", fontSize: "1.25rem" }}
            >
              {financialData.timeTracking.totalHours.toFixed(1)}h
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="caption" sx={{ color: "#64748B" }}>
                {financialData.timeTracking.entries} entries
              </Typography>
              <Typography
                variant="caption"
                sx={{ color: "#F59E0B", fontWeight: 600 }}
              >
                {financialData.timeTracking.unbilledHours.toFixed(1)}h unbilled
              </Typography>
            </Box>
          </Box>

          {/* Expenses */}
          <Box
            sx={{
              flex: "1 1 180px",
              p: 1.5,
              borderRadius: "0.75rem",
              bgcolor: "#F8FAFC",
              border: "1px solid #E2E8F0",
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box
                sx={{
                  width: 28,
                  height: 28,
                  borderRadius: "6px",
                  bgcolor: "#F0FDF4",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <DescriptionRounded
                  sx={{ fontSize: "0.9rem", color: "#10B981" }}
                />
              </Box>
              <Typography
                variant="caption"
                sx={{ fontWeight: 600, color: "#475569" }}
              >
                Expenses
              </Typography>
            </Box>
            <Typography
              sx={{ fontWeight: 700, color: "#1E293B", fontSize: "1.25rem" }}
            >
              {matterCurrencySymbol}
              {financialData.expenses.totalAmount.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="caption" sx={{ color: "#64748B" }}>
                {financialData.expenses.entries} entries
              </Typography>
              <Typography
                variant="caption"
                sx={{ color: "#EF4444", fontWeight: 600 }}
              >
                {matterCurrencySymbol}
                {financialData.expenses.unbilledAmount.toLocaleString()}{" "}
                unbilled
              </Typography>
            </Box>
          </Box>

          {/* Billing */}
          <Box
            sx={{
              flex: "1 1 180px",
              p: 1.5,
              borderRadius: "0.75rem",
              bgcolor: "#F8FAFC",
              border: "1px solid #E2E8F0",
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box
                sx={{
                  width: 28,
                  height: 28,
                  borderRadius: "6px",
                  bgcolor: "#FEF3C7",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ReceiptRounded sx={{ fontSize: "0.9rem", color: "#F59E0B" }} />
              </Box>
              <Typography
                variant="caption"
                sx={{ fontWeight: 600, color: "#475569" }}
              >
                Billing
              </Typography>
            </Box>
            <Typography
              sx={{ fontWeight: 700, color: "#1E293B", fontSize: "1.25rem" }}
            >
              {matterCurrencySymbol}
              {financialData.billing.totalBilled.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="caption" sx={{ color: "#64748B" }}>
                {financialData.billing.billsCount} bills
              </Typography>
              <Typography
                variant="caption"
                sx={{ color: "#10B981", fontWeight: 600 }}
              >
                {matterCurrencySymbol}
                {financialData.billing.totalCollected.toLocaleString()}{" "}
                collected
              </Typography>
            </Box>
          </Box>

          {/* Quick Bill */}
          <Box
            sx={{
              flex: "1 1 180px",
              p: 1.5,
              borderRadius: "0.75rem",
              bgcolor: "#F8FAFC",
              border: "1px solid #E2E8F0",
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Box
                sx={{
                  width: 28,
                  height: 28,
                  borderRadius: "6px",
                  bgcolor: "#DBEAFE",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <PaidRounded sx={{ fontSize: "0.9rem", color: "#3B82F6" }} />
              </Box>
              <Typography
                variant="caption"
                sx={{ fontWeight: 600, color: "#475569" }}
              >
                Quick Bill
              </Typography>
            </Box>
            <Typography
              sx={{ fontWeight: 700, color: "#1E293B", fontSize: "1.25rem" }}
            >
              {matterCurrencySymbol}
              {quickBillRows
                .reduce(
                  (sum, row) => sum + parseFloat(row.billable_amount || 0),
                  0,
                )
                .toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography variant="caption" sx={{ color: "#64748B" }}>
                {quickBillRows.length} items
              </Typography>
              <Button
                variant="contained"
                size="small"
                sx={{
                  textTransform: "none",
                  fontSize: "0.75rem",
                  py: 0.25,
                  px: 1,
                  borderRadius: "0.5rem",
                  bgcolor: "#3B82F6",
                  "&:hover": { bgcolor: "#2563EB" },
                }}
                onClick={() => {
                  handleBulkBill();
                }}
                disabled={quickBillRows.length === 0}
              >
                Bill Now
              </Button>
            </Box>
          </Box>
        </Box>

        {/* Quick Bill Table */}
        {quickBillRows.length > 0 && (
          <Box
            sx={{
              backgroundColor: "#fff",
              borderRadius: "0.8rem",
              p: "1rem",
              border: "1px solid #e5e7eb",
              mb: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
              }}
            >
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 600, fontSize: "0.9375rem" }}
              >
                Quick Bill Items
              </Typography>
              <Typography variant="caption" sx={{ color: "#6b7280" }}>
                Total: {matterCurrencySymbol}
                {quickBillRows
                  .reduce(
                    (sum, row) => sum + parseFloat(row.billable_amount || 0),
                    0,
                  )
                  .toLocaleString()}
              </Typography>
            </Box>

            <Box sx={{ maxHeight: 300, overflow: "auto" }}>
              <Box sx={{ display: "table", width: "100%" }}>
                {/* Table Header */}
                <Box
                  sx={{
                    display: "table-row",
                    bgcolor: "#f9fafb",
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                  }}
                >
                  {["Description", "Type", "Date", "Amount"].map((header) => (
                    <Box
                      key={header}
                      sx={{
                        display: "table-cell",
                        p: 1,
                        fontWeight: 600,
                        fontSize: "0.75rem",
                        color: "#374151",
                        borderBottom: "1px solid #e5e7eb",
                      }}
                    >
                      {header}
                    </Box>
                  ))}
                </Box>

                {/* Table Rows */}
                {quickBillRows.slice(0, 5).map((row) => (
                  <Box
                    key={row.id}
                    sx={{
                      display: "table-row",
                      "&:hover": { bgcolor: "#f8fafc" },
                    }}
                  >
                    <Box
                      sx={{
                        display: "table-cell",
                        p: 1,
                        borderBottom: "1px solid #f3f4f6",
                      }}
                    >
                      <Typography variant="body2" sx={{ fontSize: "0.875rem" }}>
                        {row.description || "No description"}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "table-cell",
                        p: 1,
                        borderBottom: "1px solid #f3f4f6",
                      }}
                    >
                      <Chip
                        label={row.type}
                        size="small"
                        sx={{
                          textTransform: "capitalize",
                          fontSize: "0.7rem",
                          height: 20,
                          bgcolor: row.type === "time" ? "#DBEAFE" : "#D1FAE5",
                          color: row.type === "time" ? "#1E40AF" : "#065F46",
                        }}
                      />
                    </Box>
                    <Box
                      sx={{
                        display: "table-cell",
                        p: 1,
                        borderBottom: "1px solid #f3f4f6",
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{ fontSize: "0.875rem", color: "#6b7280" }}
                      >
                        {new Date(row.create_at).toLocaleDateString()}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "table-cell",
                        p: 1,
                        borderBottom: "1px solid #f3f4f6",
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 600, fontSize: "0.875rem" }}
                      >
                        {matterCurrencySymbol}
                        {parseFloat(row.billable_amount || 0).toLocaleString(
                          "en-US",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        )}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>

              {quickBillRows.length > 5 && (
                <Box sx={{ textAlign: "center", pt: 1 }}>
                  <Typography variant="caption" sx={{ color: "#6b7280" }}>
                    + {quickBillRows.length - 5} more items
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        )}
      </Box>
    ),
    "Matter Detail": isLoading ? (
      <MatterDetailSkeleton />
    ) : (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {/* Main Matter Information */}
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: "0.8rem",
            p: "1rem",
            border: "1px solid #e5e7eb",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              mb: "1.5rem",
            }}
          >
            <Box
              sx={{
                width: 32,
                height: 32,
                borderRadius: "8px",
                bgcolor: "#eff6ff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <DescriptionRounded
                sx={{ color: "primary.main", fontSize: 18 }}
              />
            </Box>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, fontSize: "0.9375rem" }}
            >
              Matter Information
            </Typography>
          </Box>

          <Grid container spacing={2.5}>
            {/* Client Information */}
            <Grid item xs={12} sm={6} md={4}>
              <Box>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "0.6875rem",
                    fontWeight: 500,
                    color: "#6b7280",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  Client
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mt: 0.5,
                    gap: 0.5,
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "0.875rem",
                      color: "#111827",
                      fontWeight: 500,
                    }}
                  >
                    {caseData?.case_related_person?.first_name
                      ? `${caseData.case_related_person.first_name} ${
                          caseData.case_related_person.last_name || ""
                        }`.trim()
                      : "Not specified"}
                  </Typography>
                  {caseData?.case_related_person?.first_name && (
                    <CopyIconButton
                      text={`${caseData.case_related_person.first_name} ${
                        caseData.case_related_person.last_name || ""
                      }`.trim()}
                      fieldName="clientName"
                    />
                  )}
                </Box>
                <Typography
                  variant="caption"
                  sx={{ color: "#6b7280", fontSize: "0.75rem", mt: 0.25 }}
                >
                  {caseData?.case_related_person?.reminder_mail || "No email"}
                </Typography>
              </Box>
            </Grid>

            {/* Matter Reference ID */}
            <Grid item xs={12} sm={6} md={4}>
              <Box>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "0.6875rem",
                    fontWeight: 500,
                    color: "#6b7280",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  Matter Ref ID
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mt: 0.5,
                    gap: 0.5,
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "0.875rem",
                      color: "#111827",
                      fontWeight: 500,
                    }}
                  >
                    {caseData?.client_ref || "Not specified"}
                  </Typography>
                  {caseData?.client_ref && (
                    <CopyIconButton
                      text={caseData.client_ref}
                      fieldName="clientRef"
                    />
                  )}
                </Box>
              </Box>
            </Grid>

            {/* Matter Name */}
            <Grid item xs={12} sm={6} md={4}>
              <Box>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "0.6875rem",
                    fontWeight: 500,
                    color: "#6b7280",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  Matter Name
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    mt: 0.5,
                    gap: 0.5,
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "0.875rem",
                      color: "#111827",
                      fontWeight: 500,
                    }}
                  >
                    {caseData?.case_name || "Not specified"}
                  </Typography>
                  {caseData?.case_name && (
                    <CopyIconButton
                      text={caseData.case_name}
                      fieldName="caseName"
                    />
                  )}
                </Box>
              </Box>
            </Grid>

            {/* Status */}
            <Grid item xs={12} sm={6} md={4}>
              <Box>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "0.6875rem",
                    fontWeight: 500,
                    color: "#6b7280",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  Status
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", mt: 0.5 }}>
                  <Chip
                    label={caseData?.case_status || "Unknown"}
                    size="small"
                    sx={{
                      textTransform: "capitalize",
                      fontWeight: 600,
                      fontSize: "0.7rem",
                      height: 22,
                      bgcolor:
                        caseData?.case_status === "open"
                          ? "#34D399"
                          : caseData?.case_status === "pending"
                            ? "#FBBF24"
                            : "#F97316",
                      color: "#fff",
                    }}
                  />
                </Box>
              </Box>
            </Grid>

            {/* Opening Date */}
            <Grid item xs={12} sm={6} md={4}>
              <Box>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "0.6875rem",
                    fontWeight: 500,
                    color: "#6b7280",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  Opening Date
                </Typography>
                <Box sx={{ mt: 0.5 }}>
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "0.875rem", color: "#111827" }}
                  >
                    {caseData?.open_date
                      ? new Date(caseData.open_date).toLocaleDateString()
                      : "Not specified"}
                  </Typography>
                </Box>
              </Box>
            </Grid>

            {/* Closing Date */}
            {caseData?.close_date && (
              <Grid item xs={12} sm={6} md={4}>
                <Box>
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: "0.6875rem",
                      fontWeight: 500,
                      color: "#6b7280",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    Closing Date
                  </Typography>
                  <Box sx={{ mt: 0.5 }}>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "0.875rem", color: "#111827" }}
                    >
                      {new Date(caseData.close_date).toLocaleDateString()}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            )}

            {/* Responsible Attorney */}
            {caseData?.case_responsible_attorney && (
              <Grid item xs={12} sm={6} md={4}>
                <Box>
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: "0.6875rem",
                      fontWeight: 500,
                      color: "#6b7280",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    Responsible Attorney
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mt: 0.5,
                      gap: 0.5,
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "0.875rem", color: "#111827" }}
                    >
                      {caseData.case_responsible_attorney.first_name
                        ? `${caseData.case_responsible_attorney.first_name} ${
                            caseData.case_responsible_attorney.last_name || ""
                          }`.trim()
                        : "Not specified"}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            )}

            {/* Originating Attorney */}
            {caseData?.case_originating_attorney && (
              <Grid item xs={12} sm={6} md={4}>
                <Box>
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: "0.6875rem",
                      fontWeight: 500,
                      color: "#6b7280",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    Originating Attorney
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mt: 0.5,
                      gap: 0.5,
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "0.875rem", color: "#111827" }}
                    >
                      {caseData.case_originating_attorney.first_name
                        ? `${caseData.case_originating_attorney.first_name} ${
                            caseData.case_originating_attorney.last_name || ""
                          }`.trim()
                        : "Not specified"}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            )}
          </Grid>
        </Box>

        {/* Billing Information */}
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: "0.8rem",
            p: "1rem",
            border: "1px solid #e5e7eb",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              mb: "1.5rem",
            }}
          >
            <Box
              sx={{
                width: 32,
                height: 32,
                borderRadius: "8px",
                bgcolor: "#eff6ff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <AttachMoneyRounded
                sx={{ color: "primary.main", fontSize: 18 }}
              />
            </Box>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, fontSize: "0.9375rem" }}
            >
              Billing Information
            </Typography>
          </Box>

          <Grid container spacing={2.5}>
            {/* Currency */}
            <Grid item xs={12} sm={6} md={4}>
              <Box>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "0.6875rem",
                    fontWeight: 500,
                    color: "#6b7280",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  Currency
                </Typography>
                <Box sx={{ mt: 0.5 }}>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "0.875rem",
                      color: "#111827",
                      fontWeight: 500,
                    }}
                  >
                    {caseData?.currency || "Not specified"}
                  </Typography>
                </Box>
              </Box>
            </Grid>

            {/* Billing Method */}
            <Grid item xs={12} sm={6} md={4}>
              <Box>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "0.6875rem",
                    fontWeight: 500,
                    color: "#6b7280",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  Billing Method
                </Typography>
                <Box sx={{ mt: 0.5 }}>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "0.875rem",
                      color: "#111827",
                      fontWeight: 500,
                    }}
                  >
                    {caseData?.billable_method
                      ? caseData.billable_method.charAt(0).toUpperCase() +
                        caseData.billable_method.slice(1).replace("_", " ")
                      : "Not specified"}
                  </Typography>
                </Box>
              </Box>
            </Grid>

            {/* Hourly Rate */}
            {caseData?.billable_method === "hourly" &&
              caseData?.billable_value && (
                <Grid item xs={12} sm={6} md={4}>
                  <Box>
                    <Typography
                      variant="caption"
                      sx={{
                        fontSize: "0.6875rem",
                        fontWeight: 500,
                        color: "#6b7280",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                      }}
                    >
                      Hourly Rate
                    </Typography>
                    <Box sx={{ mt: 0.5 }}>
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: "0.875rem",
                          color: "#111827",
                          fontWeight: 500,
                        }}
                      >
                        {matterCurrencySymbol}
                        {parseFloat(
                          caseData.billable_value || 0,
                        ).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              )}

            {/* Billable Status */}
            <Grid item xs={12} sm={6} md={4}>
              <Box>
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: "0.6875rem",
                    fontWeight: 500,
                    color: "#6b7280",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  Billable
                </Typography>
                <Box sx={{ mt: 0.5 }}>
                  <Chip
                    label={caseData?.billable ? "Yes" : "No"}
                    size="small"
                    sx={{
                      fontWeight: 600,
                      fontSize: "0.7rem",
                      height: 22,
                      bgcolor: caseData?.billable ? "#10B981" : "#EF4444",
                      color: "#fff",
                    }}
                  />
                </Box>
              </Box>
            </Grid>

            {/* Budget */}
            {caseData?.budget && (
              <Grid item xs={12} sm={6} md={4}>
                <Box>
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: "0.6875rem",
                      fontWeight: 500,
                      color: "#6b7280",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                    }}
                  >
                    Budget
                  </Typography>
                  <Box sx={{ mt: 0.5 }}>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "0.875rem",
                        color: "#111827",
                        fontWeight: 500,
                      }}
                    >
                      {matterCurrencySymbol}
                      {parseFloat(caseData.budget || 0).toLocaleString(
                        "en-US",
                        {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        },
                      )}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            )}
          </Grid>
        </Box>

        {/* Custom Fields - Display all sections */}
        {customFieldSections.length > 0 && (
          <Box
            sx={{
              backgroundColor: "#fff",
              borderRadius: "0.8rem",
              p: "1rem",
              border: "1px solid #e5e7eb",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                mb: "1.5rem",
              }}
            >
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: "8px",
                  bgcolor: "#eff6ff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ExtensionRounded
                  sx={{ color: "primary.main", fontSize: 18 }}
                />
              </Box>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: 600, fontSize: "0.9375rem" }}
              >
                Custom Fields
              </Typography>
            </Box>

            {customFieldSections.map((section, sectionIndex) => (
              <Box
                key={sectionIndex}
                sx={{
                  mb: sectionIndex < customFieldSections.length - 1 ? 3 : 0,
                }}
              >
                {section.sectionName && section.sectionName.trim() && (
                  <Typography
                    variant="overline"
                    sx={{
                      display: "block",
                      color: "#6b7280",
                      fontWeight: 600,
                      fontSize: "0.75rem",
                      letterSpacing: "0.5px",
                      mb: 2,
                      textTransform: "uppercase",
                    }}
                  >
                    {section.sectionName}
                  </Typography>
                )}

                <Grid container spacing={2.5}>
                  {section.fields &&
                    Array.isArray(section.fields) &&
                    section.fields.map((field, fieldIndex) => (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        key={`${sectionIndex}-${fieldIndex}`}
                      >
                        <Box>
                          <Typography
                            variant="caption"
                            sx={{
                              fontSize: "0.6875rem",
                              fontWeight: 500,
                              color: "#6b7280",
                              textTransform: "uppercase",
                              letterSpacing: "0.5px",
                            }}
                          >
                            {field.label ||
                              field.name ||
                              `Field ${fieldIndex + 1}`}
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              mt: 0.5,
                              gap: 0.5,
                            }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                fontSize: "0.875rem",
                                color: "#111827",
                                wordBreak: "break-word",
                              }}
                            >
                              {(() => {
                                if (
                                  field.value === null ||
                                  field.value === undefined ||
                                  field.value === ""
                                ) {
                                  return "Not specified";
                                }

                                // Handle different field types
                                if (
                                  field.field_type === "date" &&
                                  field.value
                                ) {
                                  return new Date(
                                    field.value,
                                  ).toLocaleDateString();
                                }

                                if (
                                  field.field_type === "currency" &&
                                  !isNaN(parseFloat(field.value))
                                ) {
                                  return `${matterCurrencySymbol}${parseFloat(
                                    field.value,
                                  ).toLocaleString("en-US", {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })}`;
                                }

                                if (
                                  field.field_type === "percent" &&
                                  !isNaN(parseFloat(field.value))
                                ) {
                                  return `${parseFloat(field.value)}%`;
                                }

                                if (field.field_type === "check_box") {
                                  return field.value ? "Yes" : "No";
                                }

                                // For pick_list values, try to find the matching label
                                if (
                                  field.field_type === "pick_list" &&
                                  field.pickList?.options
                                ) {
                                  const option = field.pickList.options.find(
                                    (opt) =>
                                      opt.value === field.value ||
                                      opt.label === field.value,
                                  );
                                  return (
                                    option?.label ||
                                    field.value ||
                                    "Not specified"
                                  );
                                }

                                return field.value || "Not specified";
                              })()}
                            </Typography>
                            {field.value && field.value !== "Not specified" && (
                              <CopyIconButton
                                text={field.value}
                                fieldName={`custom_${sectionIndex}_${fieldIndex}`}
                              />
                            )}
                          </Box>

                          {/* Show tooltip text if available */}
                          {field.tooltipText && (
                            <Typography
                              variant="caption"
                              sx={{
                                color: "#9ca3af",
                                fontSize: "0.7rem",
                                fontStyle: "italic",
                                mt: 0.25,
                                display: "block",
                              }}
                            >
                              {field.tooltipText}
                            </Typography>
                          )}
                        </Box>
                      </Grid>
                    ))}
                </Grid>
              </Box>
            ))}
          </Box>
        )}

        {/* Empty State for Custom Fields */}
        {(!customFieldSections || customFieldSections.length === 0) && (
          <Box
            sx={{
              backgroundColor: "#fff",
              borderRadius: "0.8rem",
              p: "3rem",
              border: "1px solid #e5e7eb",
              textAlign: "center",
            }}
          >
            <ExtensionRounded
              sx={{ fontSize: 48, color: "grey.400", mb: 1.5 }}
            />
            <Typography variant="h6" color="text.secondary" gutterBottom>
              No Custom Fields
            </Typography>
            <Typography variant="body2" color="text.secondary">
              No custom fields have been configured for this matter
            </Typography>
          </Box>
        )}
      </Box>
    ),
    Tasks: isLoading ? (
      <TableSkeleton rows={5} columns={4} />
    ) : (
      <TaskTableForDash
        tasks={allTask}
        loading={taskLoading}
        height="100%"
        minHeight={0}
        emptyStateText={"There are no tasks for this Matter"}
        pagination={{
          page: taskPage,
          pageSize: taskPageSize || 10,
          rowCount: taskRowCount || 0,
          count: taskRowCount || 0,
          hasNextPage: taskNextPage != null,
          hasPreviousPage: taskPreviousPage != null,
        }}
        onPageChange={handleTaskPageChange}
        hiddenColumns={["matter_ref_id", "assigned_by", "created_date"]}
        showFilterChips={false}
        token={token}
        teamMemberLawyerId={teamMemberLawyerId}
        onRefresh={() => {
          dispatch(
            getAllTask({
              url: `${backend_api}task/task-register/?case=${id}`,
              token: token,
              page: taskPage,
              pageSize: taskPageSize,
              teamMemberLawyerId,
            }),
          );
        }}
      />
    ),
    Activity: isLoading ? (
      <TableSkeleton rows={5} columns={5} />
    ) : (
      <ActivityTableForDash
        activities={allActivities}
        loading={activityLoading}
        height="100%"
        minHeight={0}
        token={token}
        pagination={{
          page: activityPage,
          pageSize: activityPageSize || 10,
          rowCount: activityRowCount || 0,
          count: activityRowCount || 0,
          hasNextPage: activityNextPage != null,
          hasPreviousPage: activityPreviousPage != null,
        }}
        onPageChange={handleActivityPageChange}
        onRefresh={() => {
          dispatch(
            getActivities({
              url: `${backend_api}firm-case/expense/?case=${id}`,
              token: token,
              page: activityPage,
              pageSize: activityPageSize,
              teamMemberLawyerId,
            }),
          );
        }}
        onBulkBill={handleBulkBill}
        hiddenColumns={["currency"]}
        showColumns={null}
        enableBulkSelection={true}
        extraBtn={() => (
          <ButtonGroup variant="outlined" size="small">
            <Button
              id="access_activities_time"
              startIcon={<AccessTimeRounded />}
              size="small"
              onClick={() =>
                showDialog(<ServiceTimeForm />, {
                  dialogTitle: "Add Time Entry",
                })
              }
            >
              Time
            </Button>
            <Button
              id="access_activities_expense"
              size="small"
              startIcon={<AttachMoneyRounded />}
              onClick={() =>
                showDialog(<ExpenseForm />, {
                  dialogTitle: "Add Expense Entry",
                })
              }
            >
              Expense
            </Button>
          </ButtonGroup>
        )}
      />
    ),
    Bills: isLoading ? (
      <TableSkeleton rows={5} columns={5} />
    ) : (
      <BillTableForDash
        bills={allBilles}
        loading={billingLoading}
        height="100%"
        minHeight={0}
        emptyStateText="No invoices for this client"
        pagination={{
          page: billPage,
          pageSize: billPageSize || 10,
          rowCount: billRowCount || 0,
          count: billRowCount || 0,
          hasNextPage: billNextPage != null,
          hasPreviousPage: billPreviousPage != null,
        }}
        onPageChange={handleBillPageChange}
        hiddenColumns={["client", "client_type", "created_date"]}
        showActionColumn={true}
        showFilterChips={false}
        token={token}
        teamMemberLawyerId={teamMemberLawyerId}
        enableEdit={false}
        enableDelete={false}
        enableSubmitApproval={false}
        enableApproveInvoice={false}
        enableSendInvoice={true}
        onRefresh={() => {
          dispatch(
            getAllBilles({
              url: `${backend_api}firm-case/bill/?case=${id}`,
              token: token,
              page: billPage,
              pageSize: billPageSize,
              teamMemberLawyerId,
            }),
          );
        }}
      />
    ),
    Documents: isLoading ? (
      <TableSkeleton rows={5} columns={4} />
    ) : (
      <DocumentTableForDash
        documents={allDocFolder}
        loading={docLoading}
        height="100%"
        minHeight={0}
        token={token}
        currentFolderId={currentFolderId}
        folders={foldersBreadcrumbs}
        pagination={{
          page: docPage,
          pageSize: docPageSize || 10,
          rowCount: docRowCount || 0,
          count: docRowCount || 0,
          hasNextPage: docNextPage != null,
          hasPreviousPage: docPreviousPage != null,
        }}
        onPageChange={handleDocumentPageChange}
        onRefresh={() => {
          dispatch(
            getAllDocFolder({
              url: currentFolderId
                ? `${backend_api}documents/document/folder/?parent=${currentFolderId}`
                : `${backend_api}documents/document/folder/?parent__isnull=true`,
              token,
              page: docPage,
              pageSize: docPageSize,
              teamMemberLawyerId,
            }),
          );
        }}
        onFolderNavigate={handleFolderNavigate}
        hiddenColumns={["category", "client"]}
        showColumns={null}
      />
    ),
    Notes: (
      <RecordNotesPanel
        module="matter"
        objectId={id}
        objectName={caseData?.case_name || caseData?.client_ref || `Matter #${id}`}
      />
    ),
  };

  if (pageNotFound) {
    return <NotFoundPage />;
  }

  return (
    <>
      {isLoading ? (
        <HeaderSkeleton />
      ) : (
        <Box sx={{ width: "100%", position: "relative" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              position: "sticky",
              top: "0rem",
              borderRadius: "5rem",
              zIndex: 100,
              mb: "1rem",
            }}
          >
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr auto",
                gap: { xs: "0.75rem", sm: "1rem" },
                alignItems: "start",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.5rem",
                  flexWrap: "wrap",
                }}
              >
                <Tooltip
                  title={generateUniqueMatterName(
                    caseData?.id,
                    caseData?.case_name,
                  )}
                  arrow
                  placement="top-start"
                >
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: { xs: "0.95rem", sm: "1.05rem" },
                      fontWeight: 600,
                      lineHeight: 1.3,
                      width: "fit-content",
                      minWidth: 0,
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      wordBreak: "break-word",
                    }}
                  >
                    {generateUniqueMatterName(
                      caseData?.id,
                      caseData?.case_name,
                    )}
                  </Typography>
                </Tooltip>

                <CopyIconButton
                  text={generateUniqueMatterName(
                    caseData?.id,
                    caseData?.case_name,
                  )}
                  fieldName="case_name"
                />
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: { xs: "0.75rem", sm: "0.85rem" },
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                  }}
                >
                  {caseData?.client_ref}
                </Typography>

                <CopyIconButton
                  text={caseData?.client_ref}
                  fieldName="client_ref"
                />

                <Typography sx={{ color: "text.disabled" }}>•</Typography>
                <Chip
                  label={caseData?.case_status || "Unknown"}
                  size="small"
                  sx={{
                    textTransform: "capitalize",
                    fontWeight: 600,
                    fontSize: "0.7rem",
                    height: 22,
                    whiteSpace: "nowrap",
                    bgcolor:
                      caseData?.case_status === "open"
                        ? "#4CAF50"
                        : caseData?.case_status === "pending"
                          ? "#FFC107"
                          : "#F44336",
                    color: "#fff",
                  }}
                />
              </Box>
              <Box sx={{ display: "flex", gap: "1rem" }}>
                <Button
                  id="access_matters_edit"
                  variant="outlined"
                  size="small"
                  color="error"
                  startIcon={<DeleteRounded />}
                  sx={{ textTransform: "capitalize" }}
                  onClick={handleDeleteCase}
                >
                  Delete Matter
                </Button>
                <Button
                  id="access_matters_edit"
                  variant="contained"
                  size="small"
                  startIcon={<DriveFileRenameOutlineRounded />}
                  sx={{ textTransform: "capitalize" }}
                  onClick={handleEditCase}
                >
                  Edit Matter
                </Button>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: "0.5rem",
                p: "0.2rem",
                borderRadius: "2rem",
                border: "1px solid #e5e5e5",
                width: "fit-content",
                position: "sticky",
                top: "0rem",
                zIndex: "99",
                backdropFilter: "blur(4px)",
              }}
            >
              {[
                "Dashboard",
                "Matter Detail",
                "Tasks",
                "Activity",
                "Bills",
                "Documents",
                "Notes",
              ].map((tab) => (
                <Button
                  key={tab}
                  variant={activeTab === tab ? "contained" : "text"}
                  sx={{
                    textTransform: "capitalize",
                    fontSize: "0.8rem",
                    transition: "all 0.2s ease",
                  }}
                  onClick={() => setActiveTab(tab)}
                  size="small"
                >
                  {tab === "all" ? "All Matters" : tab}
                </Button>
              ))}
            </Box>
          </Box>
        </Box>
      )}

      {isLoading ? (
        <Box sx={{ mt: 2 }}>
          {activeTab === "Dashboard" && <DashboardTabSkeleton />}
          {activeTab === "Matter Detail" && <MatterDetailSkeleton />}
          {activeTab === "Tasks" && <TableSkeleton rows={5} columns={4} />}
          {activeTab === "Activity" && <TableSkeleton rows={5} columns={5} />}
          {activeTab === "Bills" && <TableSkeleton rows={5} columns={5} />}
          {activeTab === "Documents" && <TableSkeleton rows={5} columns={4} />}
          {activeTab === "Notes" && <TableSkeleton rows={4} columns={1} />}
        </Box>
      ) : (
        tabComponents[activeTab]
      )}

      {/* Snackbar for copy feedback */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity="success"
          sx={{
            width: "100%",
            fontSize: "0.875rem",
            borderRadius: "0.5rem",
            boxShadow: "0 0.25rem 0.5rem rgba(0, 0, 0, 0.1)",
          }}
        >
          Copied to clipboard!
        </Alert>
      </Snackbar>
    </>
  );
};

export default React.memo(CaseDashboard);
